var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-col',{staticClass:"parent-dashboard d-flex-column align-center justify-start",attrs:{"cols":"12"}},[_c('ParentInfoContainer'),_c('ParentInfoContainer'),_c('AdminSnackbar',{attrs:{"snackbar":_vm.snackbar,"isSuccess":_vm.isSuccess,"message":_vm.message}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }